import Axios from "axios";
import {
  SET_LC_BANK_LIST,
  UNSET_LC_BANK_LIST,
  SET_LC_BANK_DETAIL,
  UNSET_LC_BANK_DETAIL,
} from "@/store/mutation-types";
import { saveUpdateLcBank, getLcBankList, getLcBankById } from "@/store/api";

// initial state
const state = {
  lcBankList: [],
  lcBankDetail: null,
};

const getters = {
  getLcBankList(state) {
    return state.lcBankList;
  },
  getLcBankDetail(state) {
    return state.lcBankDetail;
  },
};

const mutations = {
  [SET_LC_BANK_LIST](state, data) {
    state.lcBankList = data;
  },
  [UNSET_LC_BANK_LIST](state) {
    state.lcBankList = [];
  },
  [SET_LC_BANK_DETAIL](state, data) {
    state.lcBankDetail = data;
  },
  [UNSET_LC_BANK_DETAIL](state) {
    state.lcBankDetail = null;
  },
};

const actions = {
  saveUpdateLcBank({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcBank, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcBankList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcBankList, data)
        .then(function (response) {
          commit("SET_LC_BANK_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_BANK_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getLcBankById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcBankById + id)
        .then(function (response) {
          commit("SET_LC_BANK_DETAIL", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_BANK_DETAIL");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

